import React from 'react'

const Lock = () => (
  <svg
    width='11'
    height='13'
    viewBox='0 0 11 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.56248 5.10099V4.06249C9.56248 1.82257 7.73991 0 5.49999 0C3.26007 0 1.43749 1.82257 1.43749 4.06249V5.10099C0.954138 5.38282 0.625 5.9011 0.625 6.49999V11.375C0.625 12.2712 1.35378 13 2.24999 13H8.74999C9.6462 13 10.375 12.2712 10.375 11.375V6.49999C10.375 5.90108 10.0458 5.3828 9.56248 5.10099ZM5.49999 1.62499C6.8441 1.62499 7.93749 2.71835 7.93749 4.06249V4.87498H3.06248V4.06249C3.06248 2.71838 4.15588 1.62499 5.49999 1.62499ZM6.31248 9.43369V10.5625H4.68749V9.43369C4.43983 9.21063 4.28125 8.89077 4.28125 8.53123C4.28125 7.85812 4.82689 7.31249 5.49999 7.31249C6.17309 7.31249 6.71873 7.85812 6.71873 8.53123C6.71873 8.89077 6.56015 9.21063 6.31248 9.43369Z'
      fill='#D5CBFF'
    />
  </svg>
)

export default Lock
